import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { CalendarEvent } from 'angular-calendar';

export enum SidenavActions {
  NewAppointment = 'New Appointment',
  NewPatient = 'Create Patient',
  SearchPatient = 'Find Patient',
  UpdateAppointment = 'Update Appointment',
  ReviewAppointment = 'Appointment Request',
  NewLocation = 'Create Location',
  SearchLocation = 'Find Location',
  NewService = 'Create Service',
  SearchService = 'Find Service',
  NewPractitioner = 'Create Practitioner',
  SearchPractitioner = 'Find Practitioner',
}

@Injectable({
  providedIn: 'root'
})


export class SideNavService {
  sidenav: MatSidenav;
  sidenavAction: SidenavActions;
  loading = false;
  newPatientEmail: string;
  public newBookingForm: CalendarEvent;
  constructor() { }

  setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  open(action: SidenavActions, newPatientEmail?: string) {
      this.sidenavAction = action;
      this.newPatientEmail = newPatientEmail; 
      console.log(this.sidenavAction === SidenavActions.SearchService)
      return this.sidenav.open();
  }


  close() {
      this.loading = false;
      return this.sidenav.close();
  }

  toggle(): void {
    this.loading = false;
    this.sidenav.toggle();
  }

  
}
